module.exports = __webpack_public_path__ + "static/media/electronics.58a27fb5.png";